export default {
  LOADING: 'CONTROL_VIEW_LOADING',
  LOADED: 'CONTROL_VIEW_LOADED',
  LOADING_STATES: 'CONTROL_VIEW_LOADING_STATES',
  LOADED_STATES: 'CONTROL_VIEW_LOADED_STATES',
};
